import React, { useState, useEffect } from "react";
import {
  Offcanvas,
  OverlayTrigger,
  Tooltip as BSTooltip,
  Button,
} from "react-bootstrap";
import downloadIcon from "../../../Assets/Images/Operation/downloadIcon.svg";
import { compName } from "../../../utils/constant";
import WidgetDetailModal from "../WidgetDetailModal";
import { useSelector } from "react-redux";
import infoIcon from "../../../Assets/Images/Action Icons/infoIcon..svg";
import { useParams } from "react-router-dom";
import emailIcon from "../../../Assets/Images/Email.svg";
import Comments from "../ListingComponent/Comments/Comment";
import { Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import moment from "moment";
import { apiCall } from "../../../utils/axiosService";
import { API_URL } from "../../../utils/apiRoutes";
import { apiResponse } from "../../../utils/apiResponse";
import "../../../Assets/Styles/component.css";
import { commonService } from "../../../utils/commonService";
import Loader from "../../Loader/Loader";
import MorningBriefingDateDetailModal from "./MorningBriefingDateDetailModal";
import DatePicker from "react-datepicker";
import CustomRangePicker from "../../../Component/CommonComponent/CustomRangePIcker";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

const ThirtyDayCommandView = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const { snapshottitle, propertyCode, snapshotId } = useParams();
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty?.propertyDetail,
  );
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty?.defaultAsOfDate,
  );
  const [tblids, settblids] = useState({
    ThirtyDayCommandViewTable: commonService.GenerateGUID(),
  });
  const widgetDetailRef = React.useRef();
  const [widgetModal, setWidgetModal] = useState(false);
  const closeWidgetModal = () => {
    setWidgetModal(false);
  };
  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState(null);
  const [showDetail, setShowDetail] = useState(false);
  const [selectedDateData, setSelectedDateData] = useState(null);
  const [marketSegmentMixData, setMarketSegmentMixData] = useState([]);
  const [rateShopData, setRateShopData] = useState(null);
  const [bookingPaceData, setBookingPaceData] = useState(null);
  const [isLoadingMarketSegmentMix, setIsLoadingMarketSegmentMix] =
    useState(false);
  const [isLoadingRateShop, setIsLoadingRateShop] = useState(false);
  const [isLoadingBookingPace, setIsLoadingBookingPace] = useState(false);
  const [hiddenDatasets, setHiddenDatasets] = useState({});

  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [activePresetRange, setActivePresetRange] = useState(null);
  const [startRangeDate, setStartRangeDate] = useState("");
  const [endRangeDate, setEndRangeDate] = useState("");

  const startRangeDateRef = React.useRef("");
  const endRangeDateRef = React.useRef("");
  const startDateArrayRef = React.useRef([]);

  useEffect(() => {
    if (para?.asOfDate) {
      const defaultStart = new Date(para.asOfDate);
      const defaultEnd = moment(defaultStart).add(29, "days").toDate();
      setStartRangeDate(defaultStart);
      setEndRangeDate(defaultEnd);
      startRangeDateRef.current = moment(defaultStart).format("YYYY-MM-DD");
      endRangeDateRef.current = moment(defaultEnd).format("YYYY-MM-DD");
    }
  }, [para?.asOfDate]);

  const handleDateChange = (event) => {
    const [start, end] = event;
    if (start) {
      startRangeDateRef.current = moment(start).format("YYYY-MM-DD");
    }
    if (end) {
      endRangeDateRef.current = moment(end).format("YYYY-MM-DD");
    }
    setStartRangeDate(event[0]);
    setEndRangeDate(event[1]);
    setActivePresetRange(null);
  };

  const handleApplyRange = (start, end) => {
    if (start && end) {
      startRangeDateRef.current = moment(start).format("YYYY-MM-DD");
      endRangeDateRef.current = moment(end).format("YYYY-MM-DD");
      if (api === 0) {
        generateMockData();
      } else {
        fetchData();
      }
    }
  };

  const toggleDataset = (label) => {
    setHiddenDatasets((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  const generateMockData = () => {
    const startDateStr =
      startRangeDateRef.current ||
      moment(para?.asOfDate || new Date()).format("YYYY-MM-DD");
    const endDateStr =
      endRangeDateRef.current ||
      moment(para?.asOfDate || new Date())
        .add(29, "days")
        .format("YYYY-MM-DD");
    const diffDays = moment(endDateStr).diff(moment(startDateStr), "days") + 1;
    const startDate = moment(startDateStr);

    const staticDays = [];
    const dummyEvents = {
      5: "Tech Conference",
      12: "City Concert",
      20: "Marathon",
    };
    const colors = ["#238636", "#d29922", "#da3633", "#238636"];

    for (let i = 0; i < diffDays; i++) {
      const current = moment(startDate).add(i, "days");
      const currentStr = current.format("YYYY-MM-DD");
      const hasEvent = !!dummyEvents[i];
      const otbOcc = Math.min(
        100,
        Math.floor(45 + Math.sin(i * 0.5) * 20 + (i % 4) * 5),
      );
      const novaForecast = Math.min(
        100,
        Math.floor(65 + Math.cos(i * 0.4) * 15 + (i % 3) * 6),
      );
      const stlyPace = Math.min(100, Math.floor(55 + Math.sin(i * 0.3) * 15));
      const myBar = 150 + (i % 7) * 12 + Math.floor(Math.sin(i) * 25);
      const compSetAvg = 160 + (i % 5) * 10 + Math.floor(Math.cos(i) * 20);
      const compSetMin = compSetAvg - 15 - Math.floor(Math.random() * 10);
      const compSetMax = compSetAvg + 15 + Math.floor(Math.random() * 10);
      const demandScore = Math.floor(60 + Math.sin(i * 0.6) * 30);
      const resolvedColor = colors[i % colors.length];

      let rateIqValue = "same";
      if (myBar < compSetAvg) {
        rateIqValue = "underpriced";
      } else if (myBar > compSetAvg) {
        rateIqValue = "overprised";
      }

      staticDays.push({
        date: currentStr,
        displayDate: current.format("M/D"),
        otbOcc,
        novaForecast,
        stlyPace,
        hasEvent,
        demandScoreColor: resolvedColor,
        demandScore,
        myBar,
        compSetAvg,
        compSetMin,
        compSetMax,
        flagColor: resolvedColor,
        eventName: hasEvent ? dummyEvents[i] : "",
        flagText: hasEvent ? "High Demand Event" : "",
        rateIq: rateIqValue,
      });
    }
    setChartData(staticDays);
    setLoading(false);
  };

  useEffect(() => {
    if (api === 0) {
      generateMockData();
    } else {
      if (para?.asOfDate) {
        fetchData();
      }
    }
  }, [para?.asOfDate, para?.propertyCode, api]);

  useEffect(() => {
    if (selectedDateData) {
      getRateShopData();
      getBookingPaceDetail();
      getMarketSegmentMixDetails();
    }
  }, [selectedDateData, para?.asOfDate, para?.propertyDetail]);

  const getBookingPaceDetail = async () => {
    let selectedDate = selectedDateData?.date;
    if (para?.asOfDate && selectedDate) {
      setIsLoadingBookingPace(true);
      try {
        let bookingPaceResponse = await apiCall(
          {
            method: "POST",
            url:
              API_URL.BASE_API_URL.SnapShot +
              API_URL.BOOKING_PACE.NEW_BOOKING_PACE,
            body: {
              asofdate: para?.asOfDate,
              propertycode: para?.propertyCode,
              startdate: commonService.getDateInDBFormat(selectedDate),
              enddate: commonService.getDateInDBFormat(selectedDate),
            },
          },
          false,
        );

        let response = apiResponse(false, bookingPaceResponse);

        if (response?.isValidate) {
          let dataFromApi = response?.data?.data;
          if (dataFromApi && dataFromApi.length > 0) {
            let labels = [];
            let RMS = [];
            let STLYRMS = [];

            // The mock chart goes from largest lead time (left) to smallest (right).
            // Sorting descending just in case.
            let sortedData = [...dataFromApi].sort(
              (a, b) => b.leadtime - a.leadtime,
            );

            sortedData.forEach((item) => {
              labels.push(item.leadtime + "d");
              RMS.push(item.currentyearper);
              STLYRMS.push(item.STLYper);
            });

            setBookingPaceData({
              labels,
              RMS,
              STLYRMS,
            });
          } else {
            setBookingPaceData(null);
          }
        }

        if (!response?.isValidate) {
          setBookingPaceData(null);
        }
      } catch (error) {
        setBookingPaceData(null);
      } finally {
        setIsLoadingBookingPace(false);
      }
    }
  };

  const getRateShopData = async () => {
    let propertyDetailFromRTK = para?.propertyDetail;
    let asOfDate = para?.asOfDate;
    let selectedDate = selectedDateData?.date;

    setIsLoadingRateShop(true);
    try {
      let byPropertyIdResponse = await apiCall(
        {
          method: "POST",
          url:
            API_URL.BASE_API_URL.RevenueManagement +
            API_URL.REVENUE_RATE_SHOP_CONFIG.GET_BY_PROPERTY_ID,
          body: {
            id: propertyDetailFromRTK?.propertyid,
          },
        },
        false,
      );

      let propertyResponse = apiResponse(false, byPropertyIdResponse);

      let CompareDate = new Date(asOfDate);
      CompareDate = new Date(CompareDate.setDate(CompareDate.getDate() - 1));

      let rateShopDataResponse = await apiCall(
        {
          method: "POST",
          url:
            API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.RATESHOP_LIST,
          body: {
            AsOfDate: asOfDate,
            propertyCode: propertyDetailFromRTK?.propertycode,
            Channel: propertyResponse?.data?.data?.channel_term
              ? propertyResponse?.data?.data?.channel_term
              : "",
            startDate: selectedDate
              ? commonService.getDateForNode(selectedDate)
              : "",
            endDate: selectedDate
              ? commonService.getDateForNode(selectedDate)
              : "",
            propertyid: propertyDetailFromRTK?.propertyid,
            CompareDate: CompareDate
              ? commonService.getDateInDBFormat(CompareDate)
              : "",
          },
        },
        false,
      );

      let response = apiResponse(false, rateShopDataResponse);

      if (response?.isValidate) {
        setRateShopData(response?.data?.data);
      }

      if (!response?.isValidate) {
        setRateShopData(null);
      }
    } catch (error) {
      setRateShopData(null);
    } finally {
      setIsLoadingRateShop(false);
    }
  };

  const getMarketSegmentMixDetails = async () => {
    let selectedDate = selectedDateData?.date || selectedDateData?.dates;
    if (para?.asOfDate && selectedDate) {
      setIsLoadingMarketSegmentMix(true);
      let customday = await apiCall(
        {
          method: "POST",
          url:
            API_URL.BASE_API_URL.SnapShot +
            API_URL.MONEY_CONTROL.MARKETSEGMENT_MIX_CHART,
          body: {
            propertyCode: para?.propertyCode,
            AsOfDate: para?.asOfDate,
            startDate: commonService.getDateForNode(selectedDate),
            endDate: commonService.getDateForNode(selectedDate),
          },
        },
        false,
      );

      let customdayresponse = apiResponse(false, customday);

      if (customdayresponse?.isValidate) {
        setMarketSegmentMixData(customdayresponse?.data?.data);
      } else {
        setMarketSegmentMixData([]);
      }
      setIsLoadingMarketSegmentMix(false);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const startDateStr =
        startRangeDateRef.current ||
        moment(para?.asOfDate || new Date()).format("YYYY-MM-DD");
      const endDateStr =
        endRangeDateRef.current ||
        moment(para?.asOfDate || new Date())
          .add(29, "days")
          .format("YYYY-MM-DD");
      const startDate = moment(startDateStr);
      const diffDays =
        moment(endDateStr).diff(moment(startDateStr), "days") + 1;

      const standardPayload = {
        AsOfDate: para?.asOfDate,
        startDate: startDateStr,
        endDate: endDateStr,
        propertyCode: para?.propertyCode,
      };

      const flagMechanismPayload = {
        asofdate: para?.asOfDate,
        startdate: startDateStr,
        enddate: endDateStr,
        propertyCode: para?.propertyCode,
      };

      const displacementPayload = {
        asofdate: para?.asOfDate,
        startdate: startDateStr,
        enddate: endDateStr,
        propertycode: para?.propertyCode,
      };

      const pricingforecastPayload = {
        AsOfDate: commonService.getDateForNode(para?.asOfDate),
        startDate: startDateStr,
        endDate: endDateStr,
        propertyCode: para?.propertyCode,
        propertyid: para?.propertyDetail?.propertyid,
        ForcastType: "ema",
      };

      const eventPayload = {
        pageNum: 1,
        pageSize: 100,
        sortColumn: "",
        sortDirection: "asc",
        searchValue: "",
        propertyid: parseInt(para?.propertyDetail?.propertyid || 0),
        startdate: null,
        enddate: null,
        eventname: "",
        eventtypeterm: "",
        yearterm: "",
      };

      // Fetch OTB
      const otbPromise = apiCall({
        method: "POST",
        url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.ORG,
        body: standardPayload,
      });

      // Fetch Forecast
      const forecastPromise = apiCall({
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.DAILY_SUMMARY.PRICING_FORECAST,
        body: pricingforecastPayload,
      });

      // Fetch STLY Pace
      const stlyPromise = apiCall({
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.DAILY_SUMMARY.STLY_LY_COMSET_RATES,
        body: standardPayload,
      });

      // Fetch Events
      const eventsPromise = apiCall({
        method: "POST",
        url: API_URL.BASE_API_URL.RevenueManagement + API_URL.EVENTS.GET_LIST,
        body: eventPayload,
      });

      // Fetch BAR
      const barPromise = apiCall({
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.RATESHOP_LIST,
        body: standardPayload,
      });

      // Fetch Comp Set
      const compSetPromise = apiCall({
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.DISPLACEMENT.DISPLACEMENT_TRANSIENT_OTB_FORECAST,
        body: displacementPayload,
      });

      // Fetch Flag Mechanism
      const flagPromise = apiCall({
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.FLAG_MECHANISM,
        body: flagMechanismPayload,
      });

      const [
        otbRes,
        forecastRes,
        stlyRes,
        eventsRes,
        barRes,
        compSetRes,
        flagRes,
      ] = await Promise.all([
        otbPromise,
        forecastPromise,
        stlyPromise,
        eventsPromise,
        barPromise,
        compSetPromise,
        flagPromise,
      ]);
      // Process live responses
      const extractData = (res) =>
        apiResponse(false, res)?.data?.data ||
        apiResponse(false, res)?.data ||
        [];

      const otbData = extractData(otbRes);
      const forecastData = extractData(forecastRes);
      const stlyData = extractData(stlyRes);
      const eventsData = extractData(eventsRes);
      const barData = extractData(barRes);
      const compSetData = extractData(compSetRes);
      const flagData = extractData(flagRes);

      const getArrData = (dataArray) =>
        Array.isArray(dataArray) ? dataArray : [];
      let days = [];
      for (let i = 0; i < diffDays; i++) {
        let current = moment(startDate).add(i, "days");
        let currentStr = current.format("YYYY-MM-DD");

        let otbMatch = getArrData(otbData).find(
          (x) =>
            (x.Date && x.Date.startsWith(currentStr)) ||
            (x.Dates && x.Dates.startsWith(currentStr)),
        );
        let forecastMatch = getArrData(forecastData).find(
          (x) =>
            (x.Dates && x.Dates.startsWith(currentStr)) ||
            (x.Date && x.Date.startsWith(currentStr)),
        );
        let stlyMatch = getArrData(stlyData).find(
          (x) =>
            (x.dates && x.dates.startsWith(currentStr)) ||
            (x.Date && x.Date.startsWith(currentStr)),
        );
        let eventsMatch = getArrData(eventsData).find(
          (x) =>
            (x.startdate &&
              moment(x.startdate).format("YYYY-MM-DD") === currentStr) ||
            (x.event_start_date &&
              moment(x.event_start_date).format("YYYY-MM-DD") === currentStr),
        );
        let abc = getArrData(barData).filter((x) => x.IsSelf === true);
        let currentDateBarData = getArrData(barData).filter(
          (x) =>
            (x.CheckInDate && x.CheckInDate.startsWith(currentStr)) ||
            (x.Date && x.Date.startsWith(currentStr)),
        );

        let myBarMatch = currentDateBarData.find((x) => x.IsSelf === true);
        let myBarRate = myBarMatch
          ? parseFloat(myBarMatch.Rate || myBarMatch.rate || 0)
          : 0;

        let compRates = currentDateBarData
          .filter((x) => x.IsSelf === false)
          .map((x) => parseFloat(x.Rate || x.rate || 0))
          .filter((rate) => rate > 0);

        let compSetAvgValue =
          compRates.length > 0
            ? compRates.reduce((a, b) => a + b, 0) / compRates.length
            : 0;

        compSetAvgValue = Math.round(compSetAvgValue * 100) / 100;

        let compSetMinValue = compRates.length > 0 ? Math.min(...compRates) : 0;
        let compSetMaxValue = compRates.length > 0 ? Math.max(...compRates) : 0;

        let rateIqValue = "";
        if (myBarRate < compSetAvgValue) {
          rateIqValue = "underpriced";
        } else if (myBarRate > compSetAvgValue) {
          rateIqValue = "overprised";
        } else {
          rateIqValue = "same";
        }

        let compSetMatch = getArrData(compSetData).find(
          (x) =>
            (x.Dates && x.Dates.startsWith(currentStr)) ||
            (x.Date && x.Date.startsWith(currentStr)),
        );
        let flagMatch = getArrData(flagData).find(
          (x) =>
            (x.dates && x.dates.startsWith(currentStr)) ||
            (x.Date && x.Date.startsWith(currentStr)),
        );

        const colorMap = {
          RED: "#da3633",
          GREEN: "#238636",
          YELLOW: "#d29922",
          ORANGE: "#d29922",
        };
        const rawFlagColor = flagMatch
          ? flagMatch.flag_color || flagMatch.color
          : null;
        const resolvedColor =
          rawFlagColor && colorMap[rawFlagColor.toUpperCase()]
            ? colorMap[rawFlagColor.toUpperCase()]
            : "#d0d7de";

        days.push({
          date: currentStr,
          displayDate: current.format("M/D"),
          otbOcc: otbMatch ? (otbMatch.OnTheBook ?? 0) : 0,
          // novaForecast:
          //   forecastMatch && forecastMatch.RMS != null ? forecastMatch.RMS : 0,
          novaForecast: forecastMatch?.RMS != null ? forecastMatch.RMS : 0,
          stlyPace: stlyMatch ? (stlyMatch.stlyotb ?? 0) : 0,

          hasEvent: !!eventsMatch,
          demandScoreColor: resolvedColor,
          demandScore: compSetMatch ? (compSetMatch.TotalDemandScore ?? 0) : 0,
          myBar: myBarRate,

          compSetAvg: compSetAvgValue,
          compSetMin: compSetMinValue,
          compSetMax: compSetMaxValue,
          flagColor: resolvedColor,
          eventName: eventsMatch
            ? eventsMatch.eventname ||
              eventsMatch.event_name ||
              eventsMatch.title ||
              ""
            : "",
          flagText: flagMatch
            ? flagMatch.message ||
              flagMatch.flag_text ||
              flagMatch.description ||
              ""
            : "",
          rateIq: rateIqValue,
        });
      }

      setChartData(days);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  const handleBarClick = (event, elements) => {
    if (api === 0) return;
    if (elements.length > 0 && chartData) {
      const index = elements[0].index;
      setSelectedDateData(chartData[index]);
      setShowDetail(true);
    }
  };

  const renderTopChart = () => {
    if (!chartData) return null;

    const labels = chartData?.map((d) => d.displayDate);
    const data = {
      labels,
      datasets: [
        {
          type: "line",
          // label: "Nova Forecast",
          label: "System Forecast",
          data: chartData?.map((d) => d.novaForecast),
          hidden: hiddenDatasets["System Forecast"],
          borderColor: "#90caf9", // light blue
          borderWidth: 2,
          pointRadius: 0,
          fill: false,
          tension: 0.4,
        },
        {
          type: "line",
          label: "STLY Pace",
          data: chartData?.map((d) => d.stlyPace),
          hidden: hiddenDatasets["STLY Pace"],
          borderColor: "#8b949e", // grey
          borderWidth: 1,
          borderDash: [5, 5],
          pointRadius: 0,
          fill: false,
          tension: 0.4,
        },
        {
          type: "bar",
          label: "OTB",
          data: chartData?.map((d) => d.otbOcc),
          hidden: hiddenDatasets["OTB"],
          backgroundColor: chartData?.map((d) =>
            d.hasEvent ? "#8a2be2" : "#3565fc",
          ), // purple for event, blue normal
          borderRadius: 4,
          barPercentage: 0.8,
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      interaction: { mode: "index", intersect: false },
      onClick: handleBarClick,
      plugins: {
        legend: { display: false },
        tooltip: {
          filter: (tooltipItem, index) => index === 0,
          backgroundColor: "#24292f",
          titleColor: "#ffffff",
          bodyColor: "#e6edf3",
          borderColor: "#57606a",
          borderWidth: 2,
          displayColors: false,
          callbacks: {
            title: function (context) {
              if (!context || !context.length) return "";
              const d = chartData[context?.[0]?.dataIndex];
              const dateStr = moment(d.date).format("ddd M/D");
              return d.hasEvent
                ? `${dateStr} · ${d.eventName || "Event"}`
                : dateStr;
            },
            label: function (context) {
              const d = chartData[context.dataIndex];
              return `OTB ${d.otbOcc} · Sys FC ${d.novaForecast} · STLY ${d.stlyPace}`;
            },
            afterLabel: function (context) {
              const d = chartData[context.dataIndex];
              let lines = [];
              //  [`Demand Score ${d.demandScore}`];
              // if (d.flagText) lines.push(`🚩 ${d.flagText}`);
              lines.push("Click for date deep dive →");
              return lines;
            },
          },
        },
      },
      scales: {
        x: {
          grid: { display: false, drawBorder: false },
          ticks: { color: "#57606a", maxTicksLimit: 15 },
        },
        y: {
          grid: { color: "#d0d7de", drawBorder: false },
          ticks: { color: "#57606a", stepSize: 25 },
          min: 0,
          suggestedMax: 100,
        },
      },
    };

    return <Bar data={data} options={options} />;
  };

  const renderBottomChart = () => {
    if (!chartData) return null;

    const labels = chartData.map((d) => d.displayDate);
    const data = {
      labels,
      datasets: [
        {
          type: "line",
          label: "My BAR",
          data: chartData.map((d) => d.myBar),
          hidden: hiddenDatasets["My BAR"],
          borderColor: "#3565fc",
          borderWidth: 2,
          pointBackgroundColor: chartData.map((d) => d.flagColor),
          pointBorderColor: "#ffffff",
          pointBorderWidth: 2,
          pointRadius: 5,
          pointHoverRadius: 7,
          fill: false,
          tension: 0.2,
        },
        {
          type: "line",
          label: "Comp Set Avg",
          data: chartData.map((d) => d.compSetAvg),
          hidden: hiddenDatasets["Comp Set Avg"],
          borderColor: "#e89234", // orange
          borderWidth: 2,
          pointRadius: 0,
          fill: false,
          tension: 0.2,
        },
        {
          type: "line",
          label: "CompSet Min",
          data: chartData.map((d) => d.compSetMin),
          hidden: hiddenDatasets["CompSet Min"],
          borderColor: "transparent",
          backgroundColor: "rgba(232, 146, 52, 0.3)",
          pointRadius: 0,
          fill: false,
          tension: 0.2,
        },
        {
          type: "line",
          label: "CompSet Max",
          data: chartData.map((d) => d.compSetMax),
          hidden: hiddenDatasets["CompSet Max"],
          borderColor: "transparent",
          backgroundColor: "rgba(232, 146, 52, 0.3)",
          pointRadius: 0,
          fill: "-1",
          tension: 0.2,
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      interaction: { mode: "index", intersect: false },
      onClick: handleBarClick,
      plugins: {
        legend: { display: false },
        tooltip: {
          filter: (tooltipItem, index) => index === 0,
          backgroundColor: "#24292f",
          titleColor: "#ffffff",
          bodyColor: "#e6edf3",
          borderColor: "#57606a",
          borderWidth: 2,
          displayColors: false,
          callbacks: {
            title: function (context) {
              if (!context || !context.length) return "";
              const d = chartData[context[0].dataIndex];
              return moment(d.date).format("ddd M/D");
            },
            label: function (context) {
              const d = chartData[context.dataIndex];
              let lines = [];
              // if (d.flagText) lines.push(`🚩 ${d.flagText}`);
              lines.push(
                `BAR ${commonService.formateAmount(d.myBar)} vs Comp avg ${commonService.formateAmount(d.compSetAvg)}`,
              );
              lines.push(
                `CompSet Min ${commonService.formateAmount(d.compSetMin)} · CompSet Max ${commonService.formateAmount(d.compSetMax)}`,
              );
              if (d.rateIq) lines.push(`Rate IQ: ${d.rateIq}`);
              return lines;
            },
            afterLabel: function () {
              return "Click for date deep dive →";
            },
          },
        },
      },
      scales: {
        x: { display: false },
        y: {
          grid: { color: "#d0d7de", drawBorder: false },
          ticks: {
            color: "#57606a",
            callback: (value) => commonService.formateAmount(value),
          },
        },
      },
    };

    return <Line data={data} options={options} />;
  };

  return (
    <div className="widget-container" style={{ position: "relative" }}>
      {api !== 0 && (
        <>
          <div className="groupiq-date-controls justify-content-end me-4 pt-1 pe-3">
            <div className="groupiq-date-input">
              <DatePicker
                id={commonService.generateGlobalClickTrackerID(
                  "ThirtyDayCommandView",
                  "range-date-picker",
                  propertyDetailFromRTK?.propertyid,
                )}
                portalId="datepicker-root"
                className="groupiq-datepicker"
                onChange={(event) => handleDateChange(event)}
                startDate={startRangeDate}
                endDate={endRangeDate}
                selectsRange
                monthsShown={2}
                open={openDatePicker}
                shouldCloseOnSelect={false}
                onClickOutside={() => setOpenDatePicker(false)}
                onInputClick={() => setOpenDatePicker(true)}
                placeholderText="MM/DD/YYYY - MM/DD/YYYY"
              >
                <div className="w-100" style={{ display: "inline-block" }}>
                  <CustomRangePicker
                    activePreset={activePresetRange}
                    setActivePreset={setActivePresetRange}
                    setOpenDatePicker={setOpenDatePicker}
                    onChange={(start, end, type) => {
                      setStartRangeDate(start);
                      setEndRangeDate(end);
                      handleApplyRange(start, end);
                    }}
                  />
                  <div className="content-inside-calendar">
                    <p>
                      {startRangeDate
                        ? commonService.getDateInFormat(startRangeDate)
                        : ""}
                      {startRangeDate && endRangeDate ? " - " : ""}
                      {endRangeDate
                        ? commonService.getDateInFormat(endRangeDate)
                        : ""}
                    </p>
                    <div className="d-flex align-items-center gap-2">
                      <button
                        className="secondary-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          setStartRangeDate(
                            startRangeDateRef.current
                              ? new Date(startRangeDateRef.current)
                              : "",
                          );
                          setEndRangeDate(
                            endRangeDateRef.current
                              ? new Date(endRangeDateRef.current)
                              : "",
                          );
                          setOpenDatePicker(false);
                          setActivePresetRange(null);
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        disabled={!(startRangeDate && endRangeDate)}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleApplyRange(startRangeDate, endRangeDate);
                          setOpenDatePicker(false);
                          setActivePresetRange(null);
                        }}
                        className="primary-btn"
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              </DatePicker>
            </div>
            {/* <Button
          id={commonService.generateGlobalClickTrackerID("ThirtyDayCommandView", "reset", propertyDetailFromRTK?.propertyid)}
          className="default-btn primary-btn"
          onClick={() => {
            if (para?.asOfDate) {
              const defaultStart = new Date(para.asOfDate);
              const defaultEnd = moment(defaultStart).add(29, "days").toDate();
              setStartRangeDate(defaultStart);
              setEndRangeDate(defaultEnd);
              startRangeDateRef.current = moment(defaultStart).format("YYYY-MM-DD");
              endRangeDateRef.current = moment(defaultEnd).format("YYYY-MM-DD");
              if (api === 0) {
                generateMockData();
              } else {
                fetchData();
              }
              setOpenDatePicker(false);
            }
          }}
        >
          RESET
        </Button> */}
          </div>
          <div className="gap-1 widget-container-menu">
            <Button className="heading-menu-btns" type="button">
              <img
                id={commonService.generateGlobalClickTrackerID(
                  "ThirtyDayCommandView",
                  "infoIcon",
                  propertyDetailFromRTK?.propertyid,
                )}
                src={infoIcon}
                alt="info"
                onClick={() => {
                  widgetDetailRef.current = {
                    widgetdetails: "",
                    usernote: "",
                    compName:
                      compName?.ThirtyDayCommandView || "ThirtyDayCommandView",
                    widgetId: para?.widgetId,
                  };
                  setWidgetModal(true);
                }}
              />
            </Button>
            {/* <Button className="heading-menu-btns" type="button">
            <img
              src={downloadIcon}
              alt="menuIcon"
              id={commonService.generateGlobalClickTrackerID("ThirtyDayCommandView","downloadIcon", propertyDetailFromRTK?.propertyid)}
              onClick={() =>
                commonService.fnExportInCSV(
                  tblids.ThirtyDayCommandViewTable,
                  `${para?.propertyCode}-ThirtyDayCommandView-${moment(new Date()).format("MMDDYYYY")}`
                )
              }
            />
          </Button> */}
          </div>
        </>
      )}

      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="chart-container">{renderTopChart()}</div>

          <div className="ds-ribbon d-flex mt-2 mb-2">
            <div
              style={{
                width: "30px",
                fontSize: "10px",
                color: "#57606a",
                alignSelf: "center",
              }}
            >
              DS
            </div>
            {chartData?.map((d, i) => (
              <OverlayTrigger
                key={`ds-${i}`}
                placement="bottom"
                overlay={
                  <BSTooltip id={`tooltip-ds-${i}`}>
                    <div style={{ textAlign: "left" }}>
                      <strong>{moment(d.date).format("ddd M/D")}</strong>
                      <br />
                      Demand Score <strong>{d.demandScore}/100</strong>
                      <br />
                      <span style={{ color: "#8b949e", fontSize: "11px" }}>
                        Click for breakdown →
                      </span>
                    </div>
                  </BSTooltip>
                }
              >
                <div
                  className="ds-segment flex-grow-1 mx-1"
                  style={{
                    height: "8px",
                    backgroundColor: d.demandScoreColor,
                    borderRadius: "2px",
                    cursor: api === 0 ? "default" : "pointer",
                  }}
                  onClick={() => {
                    if (api === 0) return;
                    setSelectedDateData(d);
                    setShowDetail(true);
                  }}
                />
              </OverlayTrigger>
            ))}
          </div>

          <div className="bottom-chart-container">{renderBottomChart()}</div>

          <div className="chart-legend">
            <div
              className="legend-item"
              onClick={() => toggleDataset("OTB")}
              style={{
                cursor: "pointer",
                opacity: hiddenDatasets["OTB"] ? 0.5 : 1,
                textDecoration: hiddenDatasets["OTB"] ? "line-through" : "none",
              }}
            >
              <div
                className="legend-color-box"
                style={{ backgroundColor: "#3565fc" }}
              ></div>{" "}
              OTB
            </div>
            <div
              className="legend-item"
              onClick={() => toggleDataset("System Forecast")}
              style={{
                cursor: "pointer",
                opacity: hiddenDatasets["System Forecast"] ? 0.5 : 1,
                textDecoration: hiddenDatasets["System Forecast"]
                  ? "line-through"
                  : "none",
              }}
            >
              <div
                className="legend-line"
                style={{ backgroundColor: "#90caf9" }}
              ></div>{" "}
              {/* Nova Forecast */}
              System Forecast
            </div>
            <div
              className="legend-item"
              onClick={() => toggleDataset("STLY Pace")}
              style={{
                cursor: "pointer",
                opacity: hiddenDatasets["STLY Pace"] ? 0.5 : 1,
                textDecoration: hiddenDatasets["STLY Pace"]
                  ? "line-through"
                  : "none",
              }}
            >
              <div className="legend-line dashed"></div> STLY Pace
            </div>
            <div className="legend-item">
              <div
                className="legend-color-box"
                style={{ backgroundColor: "#8a2be2" }}
              ></div>{" "}
              Event night
            </div>
            <div
              className="legend-item"
              onClick={() => toggleDataset("My BAR")}
              style={{
                cursor: "pointer",
                opacity: hiddenDatasets["My BAR"] ? 0.5 : 1,
                textDecoration: hiddenDatasets["My BAR"]
                  ? "line-through"
                  : "none",
              }}
            >
              <div
                className="legend-line"
                style={{ backgroundColor: "#3565fc" }}
              ></div>{" "}
              My BAR
            </div>
            <div
              className="legend-item"
              onClick={() => toggleDataset("Comp Set Avg")}
              style={{
                cursor: "pointer",
                opacity: hiddenDatasets["Comp Set Avg"] ? 0.5 : 1,
                textDecoration: hiddenDatasets["Comp Set Avg"]
                  ? "line-through"
                  : "none",
              }}
            >
              <div
                className="legend-line"
                style={{ backgroundColor: "#e89234" }}
              ></div>{" "}
              Comp Set Avg
            </div>
            <div
              className="legend-item"
              onClick={() => toggleDataset("CompSet Min")}
              style={{
                cursor: "pointer",
                opacity: hiddenDatasets["CompSet Min"] ? 0.5 : 1,
                textDecoration: hiddenDatasets["CompSet Min"]
                  ? "line-through"
                  : "none",
              }}
            >
              <div
                className="legend-color-box"
                style={{ backgroundColor: "rgba(232, 146, 52, 0.3)" }}
              ></div>{" "}
              CompSet Min
            </div>
            <div
              className="legend-item"
              onClick={() => toggleDataset("CompSet Max")}
              style={{
                cursor: "pointer",
                opacity: hiddenDatasets["CompSet Max"] ? 0.5 : 1,
                textDecoration: hiddenDatasets["CompSet Max"]
                  ? "line-through"
                  : "none",
              }}
            >
              <div
                className="legend-color-box"
                style={{ backgroundColor: "rgba(232, 146, 52, 0.3)" }}
              ></div>{" "}
              CompSet Max
            </div>
            <div className="legend-item">
              <div
                className="legend-color-box"
                style={{ backgroundColor: "#da3633", borderRadius: "50%" }}
              ></div>{" "}
              Pace ahead · rate flat
            </div>
            <div className="legend-item">
              <div
                className="legend-color-box"
                style={{
                  background:
                    "linear-gradient(to right, #238636, #d29922, #da3633)",
                }}
              ></div>{" "}
              Demand Score ribbon (0-100)
            </div>
          </div>
        </>
      )}
      {selectedDateData && showDetail && (
        <MorningBriefingDateDetailModal
          showDetail={showDetail}
          setShowDetail={setShowDetail}
          selectedDateData={selectedDateData}
          marketSegmentMixData={marketSegmentMixData}
          rateShopData={rateShopData}
          bookingPaceData={bookingPaceData}
          isLoadingRateShop={isLoadingRateShop}
          isLoadingBookingPace={isLoadingBookingPace}
          isLoadingMarketSegmentMix={isLoadingMarketSegmentMix}
        />
      )}
      {api !== 0 && (
        <Comments
          widgetDetails={para}
          editorId={"ThirtyDayCommandView" + tblids.ThirtyDayCommandViewTable}
        />
      )}
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={closeWidgetModal}
          data={widgetDetailRef.current}
        />
      )}
    </div>
  );
};

export default ThirtyDayCommandView;
